const formatObjectPosition = hotspot => {
  return `${hotspot?.x ? hotspot.x * 100 : 50}% ${
    hotspot?.y ? hotspot.y * 100 : 50
  }%`;
};
export default formatObjectPosition;
